import { Component, OnInit } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IAuroraState } from 'src/app/_apps/aurora.state';
import { Project } from 'src/app/_apps/ostk/domain/models';
import * as fromOstkStore from 'src/app/_apps/ostk/store';

@Component({
    selector: 'aa-project-viewer',
    templateUrl: './project-viewer.component.html',
    styleUrls: [
        './project-viewer.component.scss'
    ],
    standalone: false
})
export class ProjectViewerComponent implements OnInit
{
    public project: Observable<Project>;

    constructor(
        private store: Store<IAuroraState>
    ) { }

    ngOnInit ()
    {
        this.project = this.store.select(fromOstkStore.getSelectedProject);
    }
}
